import AnswerSecurityQuestionsController from './controllers/answerSecurityQuestionsCtrl.js';
import ChangePasswordController from './controllers/changePasswordCtrl.js';
import CreateSecurityQuestionsController from './controllers/createSecurityQuestionsCtrl.js';
import ForgotPasswordController from './controllers/forgotPasswordCtrl.js';
import ForgotPasswordEmailConfirmationController from './controllers/forgotPasswordEmailConfirmationCtrl.js';
import LockedUserController from './controllers/lockedOutCtrl.js';
import LoginController from './controllers/loginCtrl.js';
import RegisterSecureTokenController from './controllers/registerSecureTokenCtrl.js';
import TermsAndConditionsAcceptController from './controllers/termsAndConditionsAcceptCtrl.js';
import UserVerificationController from './controllers/userVerificationCtrl.js';
import UserVerificationResetController from './controllers/userVerificationResetCtrl.js';
import VerifySecurityMethodModalController from './controllers/verifySecurityMethodModalCtrl.js';
import VerifySecurityMethodsController from './controllers/verifySecurityMethodsCtrl.js';

angular
    .module('channel.login', [])
    .controller('AnswerSecurityQuestionsController', AnswerSecurityQuestionsController)
    .controller('ChangePasswordController', ChangePasswordController)
    .controller('CreateSecurityQuestionsController', CreateSecurityQuestionsController)
    .controller('ForgotPasswordController', ForgotPasswordController)
    .controller(
        'ForgotPasswordEmailConfirmationController',
        ForgotPasswordEmailConfirmationController
    )
    .controller('LockedOutController', LockedUserController)
    .controller('LoginController', LoginController)
    .controller('RegisterSecureTokenController', RegisterSecureTokenController)
    .controller('TermsAndConditionsAcceptController', TermsAndConditionsAcceptController)
    .controller('UserVerificationController', UserVerificationController)
    .controller('UserVerificationResetController', UserVerificationResetController)
    .controller('VerifySecurityMethodModalController', VerifySecurityMethodModalController)
    .controller('VerifySecurityMethodsController', VerifySecurityMethodsController);
